<template>
    <div>
        <div class="paragraph">
            <div v-if="currentPage == 1">
                <p class="h1 center">国务院办公厅文件</p>
                <p class="center">国办发〔2007〕72号</p>
                <p class="indent">国务院办公厅关于限制生产销售使用塑料购物袋的通知</p>
                <p class="indent">各省、自治区、直辖市人民政府，国务院各部委、各直属机构：</p>
                <p class="indent">塑料购物袋是日常生活中的易耗品，我国每年都要消耗大量的塑料购物袋。塑料购物袋在为消费者提供便利的同时，由于过量使用及回收处理不到位等原因，也造成了严重的能源资源浪费和环境污染。特别是超薄塑料购物袋容易破损，大多被随意丢弃，成为“白色污染”的主要来源。目前越来越多的国家和地区已经限制塑料购物袋的生产、销售、使用。为落实科学发展观，建设资源节约型和环境友好型社会，从源头上采取有力措施，督促企业生产耐用、易于回收的塑料购物袋，引导、鼓励群众合理使用塑料购物袋，促进资源综合利用，保护生态环境，进一步推进节能减排工作，经国务院同意，现就严格限制塑料购物袋的生产、销售、使用等有关事项通知如下：</p>
                <p class="indent bold">一、禁止生产、销售、使用超薄塑料购物袋</p>
                <p class="indent">从2008年6月1日起，在全国范围内禁止生产、销售、使用厚度小于0.025毫米的塑料购物袋（以下简称超薄塑料购物袋）。发展改革委要抓紧修订《产业结构调整指导目录》，将超薄塑料购物袋列入淘汰类产品目录。质检总局要加快修订塑料购物袋国家标准，制订醒目的合格塑料购物袋产品标志，研究推广塑料购物袋快速简易检测方法，督促企业严格按国家标准组织生产，保证塑料购物袋的质量。</p>
                <p class="indent bold">二、实行塑料购物袋有偿使用制度</p>
                <p class="indent">超市、商场、集贸市场等商品零售场所是使用塑料购物袋最集中的场所，而且目前大多免费提供塑料购物袋。为引导群众合理使用、节约使用塑料购物袋，自2008年6月1日起，在所有超市、商场、集贸市场等商品零售场所实行塑料购物袋有偿使用制度，一律不得免费提供塑料购物袋。商品零售场所必须对塑料购物袋明码标价，并在商品价外收取塑料购物袋价款，不得无偿提供或将塑料购物袋价款隐含在商品总价内合并收取。商务部要会同发展改革委制订商品零售场所塑料购物袋有偿使用的具体管理办法，并切实抓好贯彻落实，逐步形成有偿使用塑料购物袋的市场环境。</p>
                <p class="indent bold">三、加强对限产限售限用塑料购物袋的监督检查</p>
                <p class="indent">质检部门要建立塑料购物袋生产企业产品质量监督机制。对违规继续生产超薄塑料购物袋的，或不按规定加贴（印）合格塑料购物袋产品标志的，以及存在其他违法违规行为的，要依照《中华人民共和国产品质量法》等法律法规，相应给予责令停止生产、没收违法生产的产品、没收违法所得、罚款等处罚。要完善质量监管措施，加大执法力度，严格执行曝光、召回、整改、处罚等制度。</p>
            </div>
            <div v-if="currentPage == 2">

                <p class="indent">工商部门要加强对超市、商场、集贸市场等商品零售场所销售、使用塑料购物袋的监督检查，对违规继续销售、使用超薄塑料购物袋等行为，要依照《中华人民共和国产品质量法》等法律法规予以查处。商品零售场所开办单位要加强对市场内销售和使用塑料购物袋的管理，督促商户销售、使用合格塑料购物袋。塑料购物袋销售企业要建立购销台账制度，防止不合格塑料购物袋流入市场。</p>
                <p class="indent">旅客列车、客船、客车、飞机、车站、机场及旅游景区等不得向旅客、游客提供超薄塑料购物袋（包装袋），铁道、交通、民航、旅游等主管部门要切实履行监督检查职责。</p>
                <p class="indent bold">四、提高废塑料的回收利用水平</p>
                <p class="indent">环卫部门要加快推行生活垃圾分类收集和分类处理，切实减少被混入垃圾焚烧或填埋的废塑料数量。废旧物资回收主管部门要加强对废塑料的回收利用管理工作，指导、支持物资回收企业建立健全回收网点，充分利用价格杠杆和提供优质服务等措施促进废塑料的回收，大力推进规模化分拣和分级利用，充分发挥塑料资源的效用。</p>
                <p class="indent">环保部门要加大对废塑料回收利用过程的环境监管，制订环境准入条件、污染控制标准和技术规范并监督实施，建立废塑料从回收、运输、贮存到再生利用的全过程环境管理体系。</p>
                <p class="indent">科技部门要加大对废塑料处理处置技术研发的支持力度，开发推广提高废塑料利用附加值的技术和产品，提高废塑料资源利用水平。</p>
                <p class="indent">财政、税务部门要尽快研究制定抑制废塑料污染的税收政策，利用税收杠杆调控塑料购物袋的生产、销售和使用，支持、鼓励废塑料综合利用产业的发展。</p>
                <p class="indent bold">五、大力营造限产限售限用塑料购物袋的良好氛围</p>
                <p class="indent">结合环境日、节能宣传周等活动，充分利用广播电视、报刊杂志、互联网等各种媒体，采取群众喜闻乐见、通俗易懂的方式，重点选择社区、村镇、学校、超市、商场、集贸市场及车站、机场、旅游景点等场所，广泛宣传“白色污染”的危害性，宣传限产限售限用塑料购物袋的重要意义，使广大群众和生产、销售企业牢固树立节约资源和保护环境意识，自觉合理使用塑料购物袋，依法生产、销售合格塑料购物袋。</p>
                <p class="indent">提倡重拎布袋子、重提菜篮子，重复使用耐用型购物袋，减少使用塑料袋，引导企业简化商品包装，积极选用绿色、环保的包装袋，鼓励企业及社会力量免费为群众提供布袋子等可重复使用的购物袋，共同营造节制使用塑料购物袋的良好氛围。</p>
            </div>
            <div v-if="currentPage == 3">

                <p class="indent bold">六、强化地方人民政府和国务院有关部门的责任</p>
                <p class="indent">地方各级人民政府负责本地区限产限售限用塑料购物袋工作，要高度重视，加强领导，周密部署，精心组织各职能部门制订具体办法并抓好落实。发展改革、商务、质检、工商等部门要各司其职、各负其责，通力协作、密切配合，确保各项限产限售限用措施落实到位。要加强行政监察和执法监督检查，切实落实执法责任追究制度，强化地方各级人民政府和国务院有关部门的责任。对行政不作为、执法不力的，要依照《中华人民共和国行政许可法》、《中华人民共和国行政处罚法》追究有关主管部门和执法机构主要负责人及相关责任人的责任。</p>
                <p class="indent">中华人民共和国国务院办公厅</p>
                <p class="indent">二○○七年十二月三十一日</p>
                <p class="indent">主题词：经济管理 资源 节约 环保 通知</p>
                <p class="indent">抄送：党中央各部门，各计划单列市人民政府，中央军委办公厅、各总部、各军兵种、各大军区。</p>
                <p class="indent">全国人大常委会办公厅，全国政协办公厅，高法院，高检院。</p>
                <p class="indent">各民主党派中央。</p>
                <p class="indent right">国务院办公厅秘书局 2008年1月4日印发</p>
            </div>
        </div>
        <div class="link-content">
            <div class="bottom margin-left">
                <div class="image-col float-left">
                    <img src="../../../assets/images/wenben.jpg" />
                </div>
                <div class="text-col float-left"><span><span class="sp-text">页码: </span></span> <span :class="{ active: currentPage == 1 }" class="page" @click="currentPage = 1">1</span> <span class="sp-text">-</span> <span :class="{ active: currentPage == 2 }" class="page" @click="currentPage = 2">2</span> <span class="sp-text">-</span> <span :class="{ active: currentPage == 3 }" class="page" @click="currentPage = 3">3</span>&nbsp;&nbsp;&nbsp;<span class="sp-text">-</span></div>
                <div class="image-col float-left no-left">
                    <img style="cursor: pointer" @click="back" src="../../../assets/images/return.jpg" />
                </div>
            </div>
            <div class="clear"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "WhitePollutionPrevent",
        data() {
            return {
                currentPage: 1
            }
        },
        methods: {
            back() {
                this.$emit('onIndexChanged',1);
            }
        }
    }
</script>
<style lang="scss" scoped>
    .paragraph {
        .red {
            color: #ff0000;
        }
        .margin-top {
            margin-top: 20px;
        }
        p {
            font-size: 13px;
            color: #800000;
            &.h1 {
                font-size: 21px;
            }
            &.center {
                text-align: center;
            }
            &.right {
                text-align: right;
            }
        }
    }
    .link-content {
        margin-top: 2%;
        margin-left: 10%;
        width: 80%;
        .bottom {
            float: left;
            width: 100%;
            height: 80px;
            margin-left: 50px;
            .float-left {
                float: left;
            }
            .image-col {
                height: 30px;
                margin-left: 15px;
                &.no-left {
                    margin-left: 5px;
                }
            }
            .text-col {
                margin-left: 15px;
            }
            img {
                width: 25px;
                height: 25px;
            }
            .margin-left {
                margin-left: 40%;
            }
            a, span {
                font-size: 15px;
                color: #000000;
                text-decoration: none;
                cursor: pointer;
                &.sp-text {
                    color: #cbf8e2;
                }
            }
            .page {
                padding: 3px 8px;
                border: 1px #aaa solid;
                background: #eee;
                box-shadow: -1px -1px 2px #ccc inset;
                font-weight: bold;
                &.active {
                    background: #4a97d4;
                    border: 1px #175187 solid;
                    color: #fff;
                    box-shadow: -1px -1px 2px #7894bd inset;
                }
            }
        }

    }
</style>